module.exports = __webpack_public_path__ + "img/Figure-3-web-min.4e88ed33.png";